import classNames from "classnames";
import Caption from "../../ui-elements/caption/Caption";
import Notification from "../base-notification/Notification";
import styles from "./ErrorNotification.module.scss";

const ErrorNotification = ({ message, className }: { message: string; className?: string }) => (
  <Notification bordered variant="danger" className={classNames(styles.error, className)}>
    <Caption bold={true} fontSize="md" dangerouslySetInnerHTML={{ __html: message }} />
  </Notification>
);

export default ErrorNotification;
